<div class="modal fade modal-size-medium" id="groupDialog" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <form [formGroup]="groupMasterForm" class="well"  (keydown)="keyDownEnterFunctiongroupAdd($event)">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabel"><i class="fa fa-plus"></i>Create Tag</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-3">
              <label class="form-control-label" for="l0">Tag
                          <span _ngcontent-c2="" style="color: red;">*</span>
              </label>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <input formControlName="GroupName" class="form-control" id="groupName" >
                <div *ngIf="groupMasterForm.controls['GroupName'].hasError('required') && groupMasterForm.controls['GroupName'].touched"
                  class="form-control-error-custom">
                  Tag name is required.
                </div>
                <div *ngIf="groupMasterForm.controls['GroupName'].hasError('pattern') && groupMasterForm.controls['GroupName'].touched" class="form-control-error-custom">
                  Please enter a valid Tag name.
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="modal-footer">
          <button id="btnsaveGroup" type="button" class="btn btn-sm btn-primary" data-dismiss="modal" [disabled]="!groupMasterForm.valid" (click)="addGroup()"><i class="fa fa-save"></i>Save</button>

          <button type="button" class="btn btn-sm" data-dismiss="modal"><i class="fa fa-times"></i>Close</button>
        </div>
      </div>
    </form>
  </div>
</div>
